import type { Taxas } from '../../../Model/ITaxa.ts'
import { getIconFromTaxa } from '../../../Util/iconUtil.tsx'
import { TooltipTrigger } from '../../../Provider/TooltipManager.tsx'
import { taxaOptions } from '../HomePage/01-CreateOrderPage/TaxaOptions.tsx'

interface AmpliconWidgetProps {
  amplicon: Taxas
  showLabel?: boolean
  showIcon?: boolean
  classNames?: string
}

export const AmpliconWidget = ({ amplicon, showLabel = true, showIcon = true, classNames = "" }: AmpliconWidgetProps) => {
  const taxaOption = taxaOptions.find((x) => x.value === amplicon)

  return (
    <>
      {showLabel && <span>{taxaOption?.label ?? '?'}</span>}
      {showIcon && (
        <TooltipTrigger tooltip={taxaOption?.label ?? 'unknown amplicon'}>
          <span>{getIconFromTaxa(amplicon, `inline-block align-baseline mr-3 ${classNames}`)}</span>
        </TooltipTrigger>
      )}
    </>
  )
}
